<template>
  <table class="print-table">
    <thead>
      <tr>
        <th width="24">序号</th>
        <th width="90">销售单号</th>
        <th width="90">物料名称</th>
        <th width="70">物料类型</th>
        <th width="120">规格(mm)</th>
        <th width="60">单位</th>
        <th width="60">数量</th>
        <th>备注</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in selfData" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ item.bill_code }}</td>
        <td>{{ item.name }}</td>
        <td>{{ item.wu_liao_type }}</td>
        <td>{{ item.spec }}</td>
        <td>{{ item.unit }}</td>
        <td>{{ item.shen_gou_counts }}</td>
        <td>{{ item.remark }}</td>
      </tr>
      <tr>
        <td>合计</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ totalCounts }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: [],
      totalCounts: 0
    }
  },
  mounted() {
    this.selfData = this.$util.deepCopy(this.data)
    this.totalCounts = this.$util.listFieldTotal(this.selfData, 'shen_gou_counts')
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin-top: 5px;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
.print-table th {
  font-weight: normal;
  background: #e0e5eb;
}
</style>
